export default __webpack_public_path__ + "static/media/icons-large5.64cf1236.svg";